import { render, staticRenderFns } from "./pro_01_vacuum_forming.vue?vue&type=template&id=c135a32e&lang=pug&"
import script from "./pro_01_vacuum_forming.vue?vue&type=script&lang=js&"
export * from "./pro_01_vacuum_forming.vue?vue&type=script&lang=js&"
import style0 from "./pro_01_vacuum_forming.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports